import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
// import { User } from 'app/core/user/user.types';
import { environment } from 'src/environments/environment';
export interface User
{
    id: string;
    name: string;
    email: string;
    avatar?: string;
    status?: string;
}
@Injectable({
  providedIn: 'root'
})
export class UserService {
  private _user: ReplaySubject<User> = new ReplaySubject<User>(1);

  constructor(private _httpClient: HttpClient) { }

  set user(value: User)
  {
      // Store the value
      this._user.next(value);
  }

  get user$(): Observable<User>
  {
      return this._user.asObservable();
  }
}
